import React from 'react'
import { Row, Col, Card } from 'react-bootstrap'

interface ReviewScaffoldProps {
  left: React.ReactNode
  center: React.ReactNode
  right: React.ReactNode
  datasetName?: string | undefined
}

const ReviewScaffold: React.FC<ReviewScaffoldProps> = ({ left, center, right }) => {
  return (
    <div className="vh-100 position-relative d-flex flex-column overflow-hidden">
      <Row className="flex-grow-1 p-3 g-3" style={{ minHeight: 0 }}>
        <Col xs={2} className="d-flex flex-column h-100" style={{ minHeight: 0 }}>
          {left}
        </Col>
        <Col xs={7} className="d-flex flex-column h-100" style={{ minHeight: 0 }}>
          <Card
            className="bg-dark border-0 d-flex align-items-center w-100 h-100"
            style={{ minHeight: 0 }}
          >
            {center}
          </Card>
        </Col>
        <Col xs={3} className="d-flex flex-column h-100 overflow-hidden" style={{ minHeight: 0 }}>
          {right}
        </Col>
      </Row>
    </div>
  )
}

export default ReviewScaffold
